import { PaginationItem, PaginationItemProps } from '@mui/material'
import Pagination from '@mui/material/Pagination'

import { TableNavigationBox } from './index.styles'
import { PaginationContainerProps } from './types'

const getPaginationId = (item: PaginationItemProps, prefix = '') => {
  if (item.type === 'previous') {
    return `${prefix}shortlist-navigation-left_arrow`
  }

  if (item.type === 'next') {
    return `${prefix}shortlist-navigation-right_arrow`
  }

  return `${prefix}shortlist_page_${item.page}`
}

export const PaginationContainer = ({ page, count, onChange, shouldShow, children }: PaginationContainerProps) => (
  <>
    {shouldShow && (
      <TableNavigationBox>
        <Pagination
          page={page}
          count={count}
          onChange={onChange}
          renderItem={item => (
            <PaginationItem
              id={getPaginationId(item)}
              /* eslint-disable-next-line react/jsx-props-no-spreading */
              {...item}
            />
          )}
        />
      </TableNavigationBox>
    )}

    {children}

    {shouldShow && (
      <TableNavigationBox>
        <Pagination
          page={page}
          count={count}
          onChange={onChange}
          renderItem={item => (
            <PaginationItem
              id={getPaginationId(item, 'bottom-')}
              /* eslint-disable-next-line react/jsx-props-no-spreading */
              {...item}
            />
          )}
        />
      </TableNavigationBox>
    )}
  </>
)
